// assets/cart-delivery.js
(function () {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var DELIVERY_KEY = 'Fecha de entrega';
  var DELIVERY_TIME_KEY = 'Horario de entrega';

  function isISODate(s) {
    return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);
  }

  function isHHMM(s) {
    return typeof s === 'string' && /^\d{2}:\d{2}$/.test(s);
  }

  function timeToMinutes(hhmm) {
    if (!isHHMM(hhmm)) return null;
    var p = hhmm.split(':');
    var h = parseInt(p[0], 10);
    var m = parseInt(p[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  }

  // "YYYY-MM-DD" -> "DD/MM/YYYY"
  function toDisplayDate(s) {
    if (!isISODate(s)) return s || '';
    var p = s.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }

  function toDisplayDateTime(dateISO, timeHHMM) {
    var d = dateISO ? toDisplayDate(dateISO) : '—';
    var t = isHHMM(timeHHMM) ? timeHHMM : '';
    return t ? (d + ' ' + t) : d;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function updateLineProperties(line, newProps) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        properties: newProps
      })
    }).then(function (r) { return r.json(); });
  }

  // ✅ Devuelve el "latest" como par { dateISO, timeHHMM }
  // Regla:
  // - Elegimos la fecha mayor (más lejana).
  // - Si empata fecha, elegimos la hora mayor (más tarde) si existe.
  function computeLatestSlotFromCart(cart) {
    var best = null; // {dateISO, timeHHMM}
    var items = cart && cart.items ? cart.items : [];

    items.forEach(function (it) {
      var props = it.properties || {};
      var d = props[DELIVERY_KEY];
      var t = props[DELIVERY_TIME_KEY];

      if (!d || !isISODate(d)) return;

      var tMin = timeToMinutes(t);
      if (tMin === null) tMin = -1;

      if (!best) {
        best = { dateISO: d, timeHHMM: isHHMM(t) ? t : '' };
        best._tMin = tMin;
        return;
      }

      if (d > best.dateISO) {
        best = { dateISO: d, timeHHMM: isHHMM(t) ? t : '' };
        best._tMin = tMin;
        return;
      }

      if (d === best.dateISO && tMin > (best._tMin || -1)) {
        best.timeHHMM = isHHMM(t) ? t : '';
        best._tMin = tMin;
      }
    });

    if (best) delete best._tMin;
    return best;
  }

  function buildPreview(cart) {
    var items = cart && cart.items ? cart.items : [];
    var lines = [];

    items.forEach(function (it, idx) {
      var props = it.properties || {};
      var d = props[DELIVERY_KEY];
      var t = props[DELIVERY_TIME_KEY];

      var label = toDisplayDateTime(isISODate(d) ? d : '', isHHMM(t) ? t : '');
      if (!label || label === '—') label = '—';

      lines.push((idx + 1) + '. ' + (it.product_title || it.title || 'Producto') + ': ' + label);
    });

    return lines.join(' · ');
  }

  // ✅ Aplica fecha + hora a todas las líneas que estén “por detrás”
  function applyLatestToAll(cart, latestSlot) {
    var items = cart && cart.items ? cart.items : [];
    if (!latestSlot || !latestSlot.dateISO || !isISODate(latestSlot.dateISO)) return Promise.resolve();

    var latestDate = latestSlot.dateISO;
    var latestTime = isHHMM(latestSlot.timeHHMM) ? latestSlot.timeHHMM : '';

    var p = Promise.resolve();

    items.forEach(function (it, idx) {
      var line = idx + 1;
      var props = it.properties || {};
      var curDate = props[DELIVERY_KEY];
      var curTime = props[DELIVERY_TIME_KEY];

      var curDateOk = isISODate(curDate);
      var curTimeOk = isHHMM(curTime);

      // Criterio de actualización:
      // - Si no tiene fecha válida, o fecha < latestDate -> actualizar fecha y hora
      // - Si fecha == latestDate pero hora distinta / inválida -> actualizar hora (si latestTime existe)
      var shouldUpdateDate = (!curDateOk || curDate < latestDate);
      var shouldUpdateTime = false;

      if (shouldUpdateDate) {
        shouldUpdateTime = true;
      } else if (curDateOk && curDate === latestDate) {
        if (latestTime) {
          shouldUpdateTime = (!curTimeOk || curTime !== latestTime);
        }
      }

      if (shouldUpdateDate || shouldUpdateTime) {
        var newProps = {};
        Object.keys(props || {}).forEach(function (k) { newProps[k] = props[k]; });

        if (shouldUpdateDate) newProps[DELIVERY_KEY] = latestDate;
        if (latestTime && shouldUpdateTime) newProps[DELIVERY_TIME_KEY] = latestTime;

        p = p.then(function () {
          return updateLineProperties(line, newProps);
        });
      }
    });

    return p;
  }

  // ✅ NUEVO: contar "tipos de producto" en carrito (por product_id; fallback variant_id)
  function countDistinctProductTypes(cart) {
    var items = cart && cart.items ? cart.items : [];
    var map = Object.create(null);

    items.forEach(function (it) {
      var key = null;

      if (it && typeof it.product_id !== 'undefined' && it.product_id !== null) {
        key = 'p:' + String(it.product_id);
      } else if (it && typeof it.variant_id !== 'undefined' && it.variant_id !== null) {
        key = 'v:' + String(it.variant_id);
      } else if (it && it.id) {
        key = 'i:' + String(it.id);
      }

      if (key) map[key] = true;
    });

    return Object.keys(map).length;
  }

  function wireCheckoutDeliveryModal() {
    var form = qs('form[action^="/cart"]');
    if (!form) return;

    if (form.dataset.checkoutDeliveryWired === '1') return;
    form.dataset.checkoutDeliveryWired = '1';

    var checkoutBtn = qs('input[type="submit"][name="checkout"]', form);
    if (!checkoutBtn) return;

    var modal = qs('#checkout-delivery-modal');
    var overlay = qs('#checkout-delivery-overlay');
    var closeBtn = qs('#checkout-delivery-close');
    var cancelBtn = qs('#checkout-delivery-cancel');
    var continueBtn = qs('#checkout-delivery-continue');
    var latestEl = qs('#lp-latest-date');
    var previewEl = qs('#lp-items-preview');

    if (!modal || !overlay || !closeBtn || !cancelBtn || !continueBtn) return;

    modal.hidden = true;
    overlay.hidden = true;

    var confirmed = false;
    var cachedCart = null;
    var cachedLatestSlot = null;

    function doCheckoutDirect() {
      confirmed = true;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(checkoutBtn);
      } else {
        checkoutBtn.click();
      }

      setTimeout(function () { confirmed = false; }, 1500);
    }

    function openModal() {
      modal.hidden = false;
      overlay.hidden = false;

      fetchCart().then(function (cart) {
        cachedCart = cart;
        cachedLatestSlot = computeLatestSlotFromCart(cart);

        if (latestEl) {
          latestEl.textContent = cachedLatestSlot
            ? toDisplayDateTime(cachedLatestSlot.dateISO, cachedLatestSlot.timeHHMM)
            : '—';
        }
        if (previewEl) {
          previewEl.textContent = buildPreview(cart);
        }
      }).catch(function () {
        if (latestEl) latestEl.textContent = '—';
      });
    }

    function closeModal() {
      modal.hidden = true;
      overlay.hidden = true;
    }

    checkoutBtn.addEventListener('click', function (e) {
      if (confirmed) return;

      e.preventDefault();
      e.stopPropagation();

      fetchCart().then(function (cart) {
        cachedCart = cart;

        var distinctTypes = countDistinctProductTypes(cart);

        if (!cart || !cart.items || !cart.items.length) {
          doCheckoutDirect();
          return;
        }

        if (distinctTypes <= 1) {
          doCheckoutDirect();
          return;
        }

        openModal();
      }).catch(function () {
        openModal();
      });
    }, true);

    form.addEventListener('submit', function (e) {
      if (confirmed) return;

      var submitter = e.submitter;
      if (submitter && submitter.name !== 'checkout') return;

      e.preventDefault();

      fetchCart().then(function (cart) {
        cachedCart = cart;

        var distinctTypes = countDistinctProductTypes(cart);

        if (!cart || !cart.items || !cart.items.length) {
          doCheckoutDirect();
          return;
        }

        if (distinctTypes <= 1) {
          doCheckoutDirect();
          return;
        }

        openModal();
      }).catch(function () {
        openModal();
      });
    });

    function onClose(e) {
      if (e) e.preventDefault();
      closeModal();
    }

    closeBtn.addEventListener('click', onClose);
    cancelBtn.addEventListener('click', onClose);
    overlay.addEventListener('click', onClose);

    continueBtn.addEventListener('click', function (e) {
      e.preventDefault();

      var modeEl = qs('input[name="lp-delivery-mode"]:checked', modal);
      var mode = modeEl ? modeEl.value : 'individual';

      var work = Promise.resolve();

      if (mode === 'latest') {
        work = (cachedCart ? Promise.resolve(cachedCart) : fetchCart())
          .then(function (cart) {
            var latestSlot = cachedLatestSlot || computeLatestSlotFromCart(cart);
            if (!latestSlot || !latestSlot.dateISO) return;
            return applyLatestToAll(cart, latestSlot);
          });
      }

      work.then(function () {
        confirmed = true;
        closeModal();

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(checkoutBtn);
        } else {
          checkoutBtn.click();
        }

        setTimeout(function () { confirmed = false; }, 1500);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', wireCheckoutDeliveryModal);

  var mo = new MutationObserver(function () {
    wireCheckoutDeliveryModal();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();